import type { ARAgingBucket } from '@/api/client'
import { cn } from '@/lib/cn'

interface Props {
  aging: ARAgingBucket
  className?: string
}

// Stacked horizontal bar that reflects how an outstanding balance is
// distributed across aging buckets. Darker shades mean older debt.
export function InvoiceAgingBar({ aging, className }: Props) {
  const total = aging.total || 1
  const segments = [
    { value: aging.bucket_0_30, shade: 'bg-muted' },
    { value: aging.bucket_30_60, shade: 'bg-muted-foreground' },
    { value: aging.bucket_60_90, shade: 'bg-muted-foreground' },
    { value: aging.bucket_90_plus, shade: 'bg-primary' },
  ]

  return (
    <div className={cn('flex h-1.5 w-full gap-0.5 overflow-hidden rounded-full', className)}>
      {segments
        .filter((s) => s.value > 0)
        .map((seg, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className={cn('h-full rounded-full', seg.shade)}
            style={{ width: `${(seg.value / total) * 100}%` }}
          />
        ))}
    </div>
  )
}
